import { TreeListColumnProps } from '@progress/kendo-react-treelist';
import { RequestDataBase } from '../../dispatcher/Types';

export type TREE_GRID_STATE_PROPS = {
  data: { [key: string]: any }[],
  expanded: number[]
}
export type TreeGridAddColumnsProps = {
  columns: TreeListColumnProps,
  expanded: number[]
}

export enum MaskEnum {
  self = 'self',
  all = 'all'
}

type TREE_GRID_COLUMN_PROPS = TreeListColumnProps | {
  cell?: React.ReactNode
}

export interface TREE_GRID_PROPS {
  columns: TREE_GRID_COLUMN_PROPS[],
  height: number,
  mask?: MaskEnum,
  requestCfg: RequestDataBase,
  rowHeight?: number,
  overflow?: string,
  /**
   * If true when server sends part of response data, dispatcher adds that part to grid and renders it
   */
  pieceByPieceLoad?: boolean,
  /**
   * If true grid will refresh data after component is mounted
   */
  refreshDataOnMount?: boolean
  moduleId?: string,
  width?: string
}

